<template>
  <div class="multiSelectPicker">
    <overlay-anchor :anchor="anchor" :directions="directions" @positioned="updatePosition">

      <div class="overlay"
           :style="{
             'max-width': (windowDimmensions.width- position.x - 5)+'px',
             'max-height': (windowDimmensions.height- position.y - 5)+'px'
           }">
        <ul class="">
          <li class="" v-for="(option, index) in visibleOptions">

          <span v-on:click="toggle(option)" v-if="option != i18n().all" class="checkbox">
            <i v-if="isSelected(option)" class="material-icons">check_box</i>
            <i v-if="!isSelected(option)" class="material-icons">check_box_outline_blank</i>
          </span>

            <span v-on:click="toggle(option)" v-if="option == i18n().all">
            <i v-if="liveValue.length == options.length" class="material-icons">check_box</i>
            <i v-if="liveValue.length != options.length" class="material-icons">check_box_outline_blank</i>
          </span>

          <span :id="'multiselect-'+uniq+'-'+index" v-on:click="toggle(option)" class="label">
            {{ display(option) }}
          </span>

          </li>
        </ul>
      </div>

    </overlay-anchor>
  </div>

</template>

<script>

  import i18n from "i18n"
  import { windowDimmensions, OverlayAnchor } from "./overlayLayer.js"
  import overlayModel from "./overlayModel.js"

  var uniqCounter = 0
  var focusLostListener = null

  export default {
    name: 'multi-select-picker',
    components: {
      OverlayAnchor
    },
    props: {
      anchor: {},
      options: {
        type: Array
      },
      value: {
        type: Array
      },
      allOption: {
        type: Boolean
      },
      without: {
        type: Boolean
      },
      many: {
      },
      display: {
        type: Function,
        default: (x)=>x.title || x
      }
    },
    data () {
      return {
        directions: [{ x:1, y:1, ax: -1, ay: 1}, { x:1, y:-1, ax: -1, ay: -1}],
        uniq: "" + (uniqCounter++),
        position: {x:0, y:0},
        liveValue: this.value
      }
    },
    computed: {
      windowDimmensions() { return windowDimmensions },
      visibleOptions() {
        let options = this.options.slice()
        console.log("ALL",this.i18n(), this.i18n().all)
        if(this.allOption) options.unshift(this.i18n().all)
        return options
      }
    },
    watch: {
      value(q) {
        this.liveValue = q.slice()
      }
    },
    methods: {
      i18n() { return i18n().multiSelect },
      updateIfChanged() {
        console.log( "UPDATE IF CHANGED" , JSON.stringify(this.value), JSON.stringify(this.liveValue))
        if(JSON.stringify(this.value) != JSON.stringify(this.liveValue)) {
          console.log('CHANGED', JSON.stringify(this.value),JSON.stringify(this.liveValue))
          this.$emit("update:value", this.liveValue)
        }
      },
      toggle(option) {
        if(option == this.i18n().all) {
          if(this.liveValue.length == this.options.length) {
            this.liveValue = []
            this.updateIfChanged();
            return;
          } else {
            this.liveValue = this.options.slice()
            this.updateIfChanged();
            return;
          }
        }
        let index = -1
        for(let i = 0; i < this.liveValue.length; i++) {
          if(JSON.stringify(this.liveValue[i]) == JSON.stringify(option)) index = i
        }
        if(index == -1) {
          this.liveValue.push(option)
        } else {
          if(this.liveValue.length < 2) return;
          this.liveValue.splice(index, 1)
        }
        this.updateIfChanged();
      },
      set(option) {
        if(option == this.i18n().all) this.liveValue = this.options.slice()
        else this.liveValue = [ option ]
        this.menuOpen = false;
        this.updateIfChanged();
      },
      isSelected(option) {
        for(let other of this.liveValue) {
          if(JSON.stringify(option) == JSON.stringify(other)) return true
        }
        return false
      },
      updatePosition(position) {
        this.position.x = position.x
        this.position.y = position.y
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .overlayAnchor {
    pointer-events: none;
  }
  .overlay {
    width: 50vw;
    pointer-events: none;
    display: flex;
    flex-direction: row;
    font-size: 16px;
    font-family: "Helvetica","Arial",sans-serif;
    color: rgba(0,0,0,.57);
    width: 100vw;
  }

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    min-width: 200px;
    pointer-events: all;
   /* max-height: 30vh;*/
    width: auto;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.2), 0 1px 5px 0 rgba(0,0,0,.12);
    background: white;
    z-index: 2;
    overflow-y: auto;

    display: flex;
    flex-direction: column;
    padding-left: 6px;
    padding-right: 6px;
  }

  li {
    padding-top: 4px;
    padding-bottom: 4px;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
  }
  li span {
    cursor: pointer;
  }
  li .checkbox {
    vertical-align: middle;
    position: relative;
    top: 2px;
    padding-right: 2px;
  }

  li .label {
    vertical-align: middle;
    flex-shrink: 0;
  }

  li:hover {
    color: black;
  }



</style>



// WEBPACK FOOTER //
// MultiSelectPicker.vue?04d315fd